//@flow
import BaseCategoriesCollection from './baseCategoriesCollection';

export default class CorporateCategoriesCollection extends BaseCategoriesCollection {
  __primaryCategoryUrlKey() {
    return 'corporate';
  }
}
